var map = {
	"./button-normal.png": 7,
	"./button-normal@2x.png": 8
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/button\-normal.*\.png$
// module id = 115
// module chunks = d-game